import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-site-header',
  imports: [RouterLink, NgOptimizedImage],
  template: `
    <header class="site-header">
      <div class="container">
        <a class="brand" routerLink="/">
          <img
            ngSrc="assets/logo.jpg"
            width="84"
            height="84"
            priority
            alt="Yeshua College logo"
          >
          <span>Yeshua College</span>
        </a>
      </div>
    </header>
  `,
  styles: `
    .site-header {
      padding: 1.75rem 0 0.5rem;
      background: transparent;
    }

    .brand {
      display: inline-flex;
      align-items: center;
      gap: 1rem;
      padding: 0.5rem 0;
      text-decoration: none;
      color: var(--color-text);
    }

    .brand img {
      width: 6.25rem;
      height: 6.25rem;
      object-fit: cover;
    }

    .brand span {
      font-size: clamp(1.65rem, 2vw, 1.9rem);
      font-weight: 400;
      letter-spacing: -0.02em;
    }

    @media (max-width: 640px) {
      .site-header {
        padding-top: 1.25rem;
      }

      .brand {
        gap: 0.875rem;
      }

      .brand img {
        width: 4.75rem;
        height: 4.75rem;
      }

      .brand span {
        font-size: 1.5rem;
      }
    }
  `
})
export class SiteHeaderComponent {}
